devToolsHookCb